export default __webpack_public_path__ + "static/media/bg.01e520ac.webp";